import { detect, fromNavigator, fromStorage } from '@lingui/detect-locale';
import { SUPPORTED_LOCALES, activateLocale } from './i18n.ts';
import type { Locale } from './i18n.ts';

const STORAGE_KEY = 'locale';

function normalizeLocale(raw: string | null | undefined): Locale | null {
  const base = raw?.split('-')[0]?.toLowerCase();
  return base !== undefined && (SUPPORTED_LOCALES as ReadonlyArray<string>).includes(base) ?
      (base as Locale)
    : null;
}

export function pickInitialLocale(): Locale {
  return normalizeLocale(detect(fromStorage(STORAGE_KEY), fromNavigator(), () => 'en')) ?? 'en';
}

export async function changeLocale(locale: Locale): Promise<void> {
  localStorage.setItem(STORAGE_KEY, locale);
  await activateLocale(locale);
}
